export default __webpack_public_path__ + "static/Press-f4669b8f23b8140ef225643da4612873.jpg";